import { MaterialStressData } from './../models/component-type';
import { Component, OnInit, Output, EventEmitter, OnDestroy } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Data } from "@angular/router";
import {
  NextPageService,
  NavigationLocation,
  PageLayout,
} from "@cvx/nextpage";
import { GougeModule } from "projects/fitnessforservice/src/services/gouge_module";
import { Component_MAEP } from "../../services/component_maep";
import { CalcTemplate } from "../../services/calctemplate";
import { FormControlsEventProxyService } from "../../services/formcontrols_eventproxy_service";
import { Utility } from "../../services/utility";
import { MatDialog } from "@angular/material/dialog";
import { WarningModalComponent } from "../warning-modal/warning-modal.component";
import { ComponentEventService } from "../../services/component_event.service";
import { ComponentTypeData  } from "../models/component-type"; //Shameer
import { Subscription } from "rxjs";


@Component({
    selector: "maep",
    templateUrl: "maep.component.html",
    standalone: false
})
export class MAEPComponent implements OnInit, OnDestroy {
  public componentMAEP = Component_MAEP;
  public calcTemplate = CalcTemplate;
  NavigationLocation = NavigationLocation;
  PageLayout = PageLayout;
  path: string;
  maepForm: FormGroup;
  typeA: number;

  validationList = [];
  // Define the output event
  @Output() summaryCalculated: EventEmitter<any> = new EventEmitter();
  @Output("nextStep") nextStep: EventEmitter<any> = new EventEmitter();

  summary: string;
  result: string;
  storageTank_enabled: boolean;
  mewp_apex_enabled: boolean;
  mewp_axialt_sl_enabled: boolean;
  mewp_snge_c_enabled: boolean;
  mewp_specific_gravity_enabled: boolean;
  mewp_liquid_head_hight_enabled: boolean;
  mewp_allowable_rem_strength_enabled: boolean;
  mewp_specific_minimum_yield_strength_enabled: boolean;
  mewp_temperature_derating__factor_enabled: boolean;
  selectionMade = false;

  sngrk_MAEP_Enabled: boolean;
  intUnit: number;

  public static emitCalCirStressData: EventEmitter<any> = new EventEmitter();
  ComponentTypeData: Data[];
  MaterialStressData: Data[];
  subscription: Subscription;
  private contextResetSubscription: Subscription;
  // Set while this component applies its own change, so it does not clear the new selection.

  //Removed the check for isApplyingContextChange as it is currently not used. --Patrick
  // private isApplyingContextChange = false;


  constructor(
    private NP: NextPageService,
    private activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private dialog: MatDialog,
    private formControlsEventProxyService: FormControlsEventProxyService,
    private componentEventService: ComponentEventService,
  ) {
    this.path = activatedRoute.snapshot["_routerState"].url;
   
    this.ComponentTypeData = [
        { value: "-1", text: ComponentTypeData.SelectType },
        { value: "0", text: ComponentTypeData.Cylinder },
        //{ value: "1", text: ComponentTypeData.ConicalShell },
    ];

   this.MaterialStressData = [
          { id: 1, text: MaterialStressData.FerriticSteel },
          { id: 2, text: MaterialStressData.StainlessSteel },
          { id: 3, text: MaterialStressData.Duplexss },
          { id: 4, text: MaterialStressData.HardNiBasedSS },
          { id: 5, text: MaterialStressData.Aluminum },
          { id: 6, text: MaterialStressData.Copper },
          { id: 7, text: MaterialStressData.TiAndZr },
        ];
  }

  ngOnInit(): void {
    this.maepForm = this._formBuilder.group({
      selectedComponentType: [
      "-1", // Default to "Select Type"
      [Validators.required, Validators.min(0), Validators.max(6)],
      ],
      comboBox1_DI_EquipInfo: [null, Validators.required], // <-- Add this line
      // Generate textboxes
      ...Array.from({ length: 11 }, (_, i) => `textBox${i + 2}_MAEP`).reduce(
        (acc, cur) => {
          acc[cur] = [null, Validators.required];
          return acc;
        },
        {}
      ),
      textBox13_MAEP: ["0.9", Validators.required],
    });

      //Component_MAEP.intEquip = -1;
      this.summary = "";
      this.result = "";
      this.intUnit = parseInt(localStorage.getItem("unitType")) || 0;
      Component_MAEP.intUnit_select = this.intUnit;
       if (!this.componentEventService.isImporting) {
        Component_MAEP.intEquip = -1;
      }
      this.setDefaults();
      this.contextResetSubscription =
        this.componentEventService.assessmentContextReset$.subscribe(() => {
          //Removed the check for isApplyingContextChange as it is currently not used. --Patrick
          // if (this.isApplyingContextChange) {
          //   return;
          // }
          this.maepForm.reset({ selectedComponentType: "-1" });
          this.maepForm.enable();
          this.maepForm.markAsPristine();
          this.maepForm.markAsUntouched();
          this.setDefaults();
          this.summary = "";
          this.result = "";
          this.validationList = [];
        });
      //this.typeASelectionSubscription();
      // this.formControlsEventProxyService.getMAEPEventSubject().subscribe((v) => {
      //   this.updateFormControlsAfterImport();
      // });
      this.updateFormControlsAfterImport();
  }
  
  setDefaults() {
        this.maepForm.controls["textBox13_MAEP"].setValue(0.9);
  }

  onChangeComboBox1_DI_EquipInfo(comboBox1Value) {
    const materialstressval = parseInt(comboBox1Value, 10);
    GougeModule.intASME_curve = materialstressval - 1;
    Component_MAEP.intmaterialstress = materialstressval;
    this.componentEventService.updateMaterialStress(materialstressval);
  }

  onComponentTypeChange(numValue): void {
    const componentTypeNumber = parseInt(numValue);
    //Commenting out because Alfonso said we don't need to reset anything when the component type changes. -- Patrick

    // Previously wiped Component_MAEP + summary/result/validation on dropdown change.
    // Kept commented for quick rollback if grey-out-only proves insufficient.
    // const previousComponentType = Component_MAEP.intEquip;
    // if (previousComponentType >= 0 && previousComponentType !== componentTypeNumber) {
    //   const damageClass = Component_MAEP.strD_class;
    //   const damageClassIndex = Component_MAEP.strD_iclass;
    //   const unitSelect = Component_MAEP.intUnit_select;
    //   Component_MAEP.MAEP_initialize();
    //   Component_MAEP.strD_class = damageClass;
    //   Component_MAEP.strD_iclass = damageClassIndex;
    //   Component_MAEP.intUnit_select = unitSelect;
    //   this.summary = "";
    //   this.result = "";
    //   this.validationList = [];
    //   this.isApplyingContextChange = true;
    //   this.isApplyingContextChange = false;
    // }

    this.maepForm.enable();
    this.maepForm.markAsPristine();
    this.maepForm.markAsUntouched();

    Component_MAEP.intEquip = componentTypeNumber;
    this.componentEventService.updateCompMAWPintEquip(componentTypeNumber);
  }

  calculateSummary(): void {
    Object.keys(this.maepForm.controls).forEach((key) => {
      this.maepForm.get(key).markAsDirty();
    });

    let valid = Component_MAEP.calc_Check(this.maepForm);
    this.validationList = Component_MAEP.validationMessage;
    if (!valid) {
      return;
    }

    if (Component_MAEP.alertMessage.length > 0) {
      this.openModal(Component_MAEP.alertMessage);
    }

    let results = Component_MAEP.MAEP_calc();
    this.summaryCalculated.emit(results);
    this.nextStep.emit();
  }

  private openModal(warningMessage: string[]): void {
    this.dialog.open(WarningModalComponent, {
      width: "600px",
      data: {
        warningMessage: warningMessage,
        caption: "Alert",
        captionCenter: false,
        cancelButtonShow: false,
      },
    });
  }

  updateFormControlsAfterImport() {

    Component_MAEP.updateMAWPFormControls(this.maepForm);
    this.validationList = [];
    // Set the dropdown value after options are rebuilt
    if (this.maepForm && Component_MAEP.intEquip !== undefined && Component_MAEP.intEquip !== null) {
      this.maepForm.controls['selectedComponentType'].setValue(Component_MAEP.intEquip.toString());
    }
    // Set Material Stress the dropdown value after options are rebuilt
    if (this.maepForm && Component_MAEP.intmaterialstress !== undefined && Component_MAEP.intmaterialstress !== null) {
      this.maepForm.controls['comboBox1_DI_EquipInfo'].setValue(Component_MAEP.intmaterialstress.toString());
    }
    
  }

  textBox2_MAEP_TextChanged(e) {
    if (Utility.isTextADouble(e)) {
      if (Component_MAEP.intEquip == 8) Component_MAEP.sngID = Number(e);
      else Component_MAEP.sngIDo = Number(e);
    }
  }

  textBox3_MAEP_TextChanged(e) {
    if (Utility.isTextADouble(e)) {
      if (Component_MAEP.intEquip == 8) Component_MAEP.sngtc = Number(e);
      else Component_MAEP.sngtnom = Number(e);
    }
  }

  textBox4_MAEP_TextChanged(e) {
    if (Utility.isTextADouble(e)) {
      if (Component_MAEP.intEquip == 8) CalcTemplate.sngMFH = Number(e);
      else Component_MAEP.sngLOSSi = Number(e);
    }
  }

  textBox5_MAEP_TextChanged(e) {
    if (Utility.isTextADouble(e)) {
      if (Component_MAEP.intEquip == 8) CalcTemplate.sngMFH_d = Number(e);
      else Component_MAEP.sngLOSSe = Number(e);
    }
  }

  textBox6_MAEP_TextChanged(e) {
    if (Utility.isTextADouble(e)) {
      Component_MAEP.sngFCAi = Number(e);
    }
  }

  textBox7_MAEP_TextChanged(e) {
    if (Utility.isTextADouble(e)) {
      Component_MAEP.sngFCAe = Number(e);
    }
  }

  textBox8_MAEP_TextChanged(e) {
    if (Utility.isTextADouble(e)) {
      if (Component_MAEP.intEquip == 8) Component_MAEP.sngtmin = Number(e);
      else Component_MAEP.sngP_d = Number(e);
    }
  }

  textBox9_MAEP_TextChanged(e) {
    if (Utility.isTextADouble(e))
        Component_MAEP.sngL = Number(e);
  }

  textBox10_MAEP_TextChanged(e) {
    if (Utility.isTextADouble(e)) Component_MAEP.sngSMYS = Number(e);
  }

  textBox11_MAEP_TextChanged(e) {
    if (Utility.isTextADouble(e)) Component_MAEP.sngSMTS = Number(e);
  }

  textBox12_MAEP_TextChanged(e) {
   if (Utility.isTextADouble(e)) Component_MAEP.sngElast = Number(e);
  }

  handleOtherCalculations(value) {
    if (Component_MAEP.intEquip === 1) {
    //  Component_MAEP.sngalpha = value;
  }
  }

  textBox13_MAEP_TextChanged(e) {
    if (Utility.isTextADouble(e)) CalcTemplate.sngRSF_a = Number(e);
    else CalcTemplate.sngRSF_a = 0.9;
  }

    ngOnDestroy(): void {
        this.contextResetSubscription?.unsubscribe();
        if (this.subscription) {
        this.subscription.unsubscribe();
        }
    }
}
